import React, { useRef } from "react";
import {Transition} from "react-transition-group";
import {slideLtrAbsoluteClassNames, slideRtlAbsoluteClassNames} from "./../../animations";
import useWizard from "./useWizard";

const clearEnter = (el) => {
    if(el) {
        el.classList.remove(slideRtlAbsoluteClassNames.enter);
        el.classList.remove(slideLtrAbsoluteClassNames.enter);
        el.classList.remove(slideRtlAbsoluteClassNames.enterActive);
        el.classList.remove(slideLtrAbsoluteClassNames.enterActive);
    }
}

const clearExit = (el) => {
    if(el) {
        el.classList.remove(slideLtrAbsoluteClassNames.exit);
        el.classList.remove(slideRtlAbsoluteClassNames.exit);
        el.classList.remove(slideLtrAbsoluteClassNames.exitActive);
        el.classList.remove(slideRtlAbsoluteClassNames.exitActive);
    }
}

export default ({renderedStep, renderedIndex, className, children, style}) => {
    const {currentStep, currentStepIndex, previousStepIndex} = useWizard();
    const contentRef = useRef(null);
    const stateRef = useRef({enter: false, exit: false});

    return <Transition
        nodeRef={contentRef}
        onEnter={() => {
            if(stateRef.current.exit) {
                clearExit(contentRef.current);
                stateRef.current.exit = false;
            }

            let anim = renderedIndex > previousStepIndex ? slideRtlAbsoluteClassNames : slideLtrAbsoluteClassNames;
            contentRef.current && contentRef.current.classList.add(anim.enter);
            stateRef.current.enter = true;
        }}
        onEntering={() => {
            setTimeout(() => {
                if(!stateRef.current.enter) return;

                let anim = renderedIndex > previousStepIndex ? slideRtlAbsoluteClassNames : slideLtrAbsoluteClassNames;
                contentRef.current &&  contentRef.current.classList.add(anim.enterActive);
            });
        }}
        onEntered={() => {
            clearEnter(contentRef.current)
            stateRef.current.enter = false;
        }}
        onExit={() => {
            if(stateRef.current.enter) {
                clearEnter(contentRef.current);
                stateRef.current.enter = false;
            }

            let anim = renderedIndex > currentStepIndex ? slideRtlAbsoluteClassNames : slideLtrAbsoluteClassNames;
            contentRef.current &&  contentRef.current.classList.add(anim.exit);
            stateRef.current.exit = true;
        }}
        onExiting={() => {
            if(!stateRef.current.exit) return;

            let anim = renderedIndex > currentStepIndex ? slideRtlAbsoluteClassNames : slideLtrAbsoluteClassNames;
            contentRef.current &&  contentRef.current.classList.add(anim.exitActive);
        }}
        onExited={() => {
            clearExit(contentRef.current);
            stateRef.current.exit = false;
        }}
        in={currentStep === renderedStep}
        unmountOnExit
        appear={renderedIndex !== 0}
        timeout={400}
    >
        <div className={className} ref={contentRef} style={style}>
            {children}
        </div>
    </Transition>
}
